import { render } from "./index.vue?vue&type=template&id=ca01da22"
import script from "./profile.ts?vue&type=script&lang=js"
export * from "./profile.ts?vue&type=script&lang=js"

import "./profile.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script